import { useAction, useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { reatomInstantTradeButtonsForm } from '../atoms/reatom-instant-buttons-form'
import { instantSellQuickOptionsAtom } from '../atoms/reatom-instant-sell'

import { InstantTradeQuickOptionsEditButton } from './instant-trade-buttons-edit-button'
import { InstantTradeQuickOptionInput } from './instant-trade-quick-option-input'

type TokenCreateFormProps = {
  onDone: () => void
}

export const InstantTradeSellButtonsForm: React.FC<TokenCreateFormProps> = (
  props,
) => {
  const [instantSellQuickOptions] = useAtom(instantSellQuickOptionsAtom, [])

  const { instantSellButtonsFormState, sellInputs } = useMemo(
    () =>
      reatomInstantTradeButtonsForm({
        buyButtons: undefined,
        sellButtons: instantSellQuickOptions,
      }),
    [instantSellQuickOptions],
  )

  const [formRequestState] = useAtom(instantSellButtonsFormState)
  const execute = useAction(instantSellButtonsFormState.execute)

  const [first] = useAtom(sellInputs![0].raw)
  const setFirst = useAction(sellInputs![0].setRaw)
  const [second] = useAtom(sellInputs![1].raw)
  const setSecond = useAction(sellInputs![1].setRaw)
  const [third] = useAtom(sellInputs![2].raw)
  const setThird = useAction(sellInputs![2].setRaw)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    await execute()

    props.onDone()
  }

  return (
    <Root>
      <Form onSubmit={handleSubmit}>
        <InstantTradeQuickOptionsEditButton
          type="submit"
          state={formRequestState.loading ? 'loading' : 'save'}
          disabled={formRequestState.loading}
        />
        <OptionInput
          disabled={formRequestState.loading}
          size="s"
          mode="percents"
          value={first.toString()}
          onChange={setFirst}
        />
        <OptionInput
          disabled={formRequestState.loading}
          size="s"
          mode="percents"
          value={second.toString()}
          onChange={setSecond}
        />
        <OptionInput
          disabled={formRequestState.loading}
          size="s"
          mode="percents"
          value={third.toString()}
          onChange={setThird}
        />
      </Form>
    </Root>
  )
}

const Root = styled.div``
const Form = styled.form`
  display: grid;
  grid-template-columns: 30px 1fr 1fr 1fr;
  gap: 2px;
  flex-direction: row;
`

const OptionInput = styled(InstantTradeQuickOptionInput)`
  --input-height: 30px;
  --input-border: 1px solid var(--background-4);
  --input-border-active: 1px solid var(--background-6);
`
